import React, { useCallback } from "react";
import { Link } from "@reach/router";
import { useUrl, useReturnToSelfState } from "@utils/navigation";
import { useRouteData } from "react-static";
import { useI18n } from "../../I18nextProvider";
import { PopupAllCollectedProps } from "./index.interface";
import { WithPrevState } from "../../utils/data";
import { useCollect } from "../../utils/navigation";
import useBodyClass from "../../utils/useBodyClass";

export default function PopupAllCollected({ place }: PopupAllCollectedProps) {
  const { places, lang } = useRouteData();
  const i18n = useI18n();
  const currentPlaceListUrl = useUrl({ type: "place" });

  const currentCinematicApresUrl = place.cinematicApres ? useUrl({ type: "cinematic", id: place.cinematicApres }) : "";

  useBodyClass("allcollected", "");

  const returnToSelf: WithPrevState = useReturnToSelfState();
  const getPlace = (id) => {
    return places.find((p) => {
      return p.id === id;
    });
  };

  const collectNext = useCollect({ type: "place", id: place.next.id });

  const onCloseAllCollected = useCallback(
    (e) => {
      collectNext();
      /* eslint no-restricted-globals: 0 */
      location.href = currentPlaceListUrl;
      e.preventDefault();
    },
    [collectNext, currentPlaceListUrl]
  );

  const onCloseEndGamePopup = () => {
    const useCollectEnd = useCollect({ type: "cinematic", id: place.cinematicApres });
    useCollectEnd();
  };

  const hasNextPlace = place && place.next && place.next.id;
  const nextPlace = hasNextPlace ? getPlace(place.next.id) : null;
  const nextCinematic = place.cinematicApres ? getPlace(place.next.id) : null;

  return (
    <main className="place allcollected" id="maincontent" tabIndex={-1}>
      <div className="wrapper">
        {hasNextPlace && (
          <>
            <Link
              aria-label={i18n.t("placeList.title")}
              className="fp-closing-btn"
              to={currentPlaceListUrl}
              state={returnToSelf}
              onClick={onCloseAllCollected}
            >
              <span className="screen-reader-only">{i18n.t("placeList.title")}</span>
            </Link>
            <div className="bg_enfants">
              <img src={require("../../assets/images/bg_all_collected_mob.png")} alt={i18n.t("placeList.title")} />
            </div>
            <h1>{i18n.t(`allcollected.unlock.${place.id}`)}</h1>
            <h2>{i18n.t(`allcollected.lieu_debloque`)}</h2>
            <h3>
              {nextPlace && (
                <>
                  {nextPlace[lang].year}
                  {" - "}
                  {nextPlace[lang].title}
                </>
              )}
            </h3>
            <Link onClick={onCloseAllCollected} className="bouton-or" to={currentPlaceListUrl} state={returnToSelf}>
              <span>{i18n.t("allcollected.txt_bouton")}</span>
            </Link>
          </>
        )}
        {!hasNextPlace && place.cinematicApres && (
          <>
            <Link
              aria-label={i18n.t("endpopup.txt_bouton")}
              className="fp-closing-btn"
              to={currentCinematicApresUrl}
              state={returnToSelf}
              onClick={onCloseEndGamePopup}
            >
              <span className="screen-reader-only">{i18n.t("endpopup.txt_bouton")}</span>
            </Link>
            <div className="bg_enfants">
              <img src={require("../../assets/images/bg_all_collected_mob.png")} alt={i18n.t("placeList.title")} />
            </div>
            <h1>{i18n.t(`allcollected.unlock.${place.id}`)}</h1>
            <h2>{i18n.t(`endpopup.tout_termine`)}</h2>
            <Link
              onClick={onCloseEndGamePopup}
              className="bouton-or"
              to={currentCinematicApresUrl}
              state={returnToSelf}
            >
              <span>{i18n.t("endpopup.txt_bouton")}</span>
            </Link>
          </>
        )}
      </div>
    </main>
  );
}
